export default __webpack_public_path__ + "static/reviewer-image-8-79db860153c572ce871eba27c7f323e5.png";